// extracted by mini-css-extract-plugin
export default {"container":"DatadogErrorBoundary_container__NY7G4","buttonContainer":"DatadogErrorBoundary_buttonContainer__VqoNo"};